import axios from 'axios';
import ServerProperties from '../../config/server.js'
import {RequestinProcess,AddPaginationURL} from '../../helper/request.action.js'
import {ToogleAuthSessionProperties} from '../action.js'

let result = []

export default {
  Register: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'User/Register/',
      {
        Username          : params.data.Username,
        Email             : params.data.Email,
        Phone             : params.data.Phone,
        Password          : params.data.Password,
        FirstName         : params.data.FirstName,
        LastName          : params.data.LastName,
        RoleAlias         : params.data.RoleAlias,
        Tag               : params.data.Tag,
        Address           : params.data.Address,
        Address2          : params.data.Address2,
        CityAbbreviations : params.data.CityAbbreviations,
        Postal            : params.data.Postal,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data.detail)
    });
  },
  Update: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'User/Update/Information/'+params.data.Alias+'/',
      {
        Email             : params.data.Email,
        Phone             : params.data.Phone,
        FirstName         : params.data.FirstName,
        LastName          : params.data.LastName,
        RoleAlias         : params.data.RoleAlias,
        Tag               : params.data.Tag,
        Address           : params.data.Address,
        Address2          : params.data.Address2,
        CityAbbreviations : params.data.CityAbbreviations,
        Postal            : params.data.Postal,
        Active            : params.data.Active.toString(),
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data.detail)
    });
  },
  UpdateSelfInformation: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API + 'User/Me/',
      {
        Email             : params.data.Email,
        Phone             : params.data.Phone,
        FirstName         : params.data.FirstName,
        LastName          : params.data.LastName,
        Role              : params.data.Role,
        Tag               : params.data.Tag,
        Address           : params.data.Address,
        Address2          : params.data.Address2,
        City              : params.data.City,
        Postal            : params.data.Postal,
        IsAdmin           : params.data.IsAdmin,
        IsStorage         : params.data.IsStorage,
        EmailNotif        : params.data.EmailNotif,
        Alias             : params.data.Alias,
        NextOfKin         : params.data.NextOfKin,
        PhoneNo           : params.data.PhoneNo
      }
    )
    .then(function (response) {
      let newResponse = response.data
      // newResponse.IsAdmin = params.data.IsAdmin
      // newResponse.IsStorage = params.data.IsStorage
      // if(typeof(params.data.EmailNotif) === 'string'){
      //   newResponse.EmailNotif = (params.data.EmailNotif === 'true')
      // }else{
      //   newResponse.EmailNotif = params.data.EmailNotif
      // }
      // params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(ToogleAuthSessionProperties(false))
      // params.RunRedux(StoreUserInformation(newResponse)) //run redux method
      params.onsuccess(params.self, newResponse)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data.detail)
    });
  },
  Delete: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'User/Delete/'+params.data.Alias+'/',
      {
        RoleAlias : params.data.RoleAlias,
        Tag:params.data.Tag,
        Address : params.data.Address,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Read: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      params.data.url === undefined ?
        ServerProperties.ATM_CLOUD.API+'User/?search='+params.data.query
      :
        params.data.url
    )
    .then(function (response) {
      if(params.action === 'Next'){
        result = result.concat(response.data.results)
      }else{
        result = response.data.results
      }
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("UserModelSetRS",{next:response.data.next,previous:response.data.previous,rs:result,query:params.data.query}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("UserModelSetRS",{next:null,previous:null,rs:[],query:''}))
      params.onfailed(error.response.data)
    });
  },
  ReadAsMaster: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API+'User/Master/')
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("UserModelSetRS",{next:null,previous:null,rs:response.data,query:''}))
    })
    .catch(function (error) {
      console.log(error.message);
      if (error.message === "Network Error"){
        // alert('Can\'t connect to server')
      } else if (error.response !== undefined){
        params.onfailed(error.response.data);
      } else {
        console.log("something wrong on model user");
      }

      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("UserModelSetRS",{next:null,previous:null,rs:[],query:''}))
    });
  },
  Exists: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API+'User/Exist/'+params.data.username+'/')
    .then(function (response) {
      // console.log(response);
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  UpdatePassword: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.put(
      ServerProperties.ATM_CLOUD.API+'User/Update/Password/',
      {
        OldPassword: params.data.OldPassword,
        NewPassword : params.data.NewPassword,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onsuccess(params.self,response)
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data.detail)
    });
  },
  Deleted: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(ServerProperties.ATM_CLOUD.API+'User/Inactive/?search='+params.data.query)
    .then(function (response) {
      // console.log(response);
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.RunRedux(AddPaginationURL("UserModelSetRS",{next:response.data.next,previous:response.data.previous,rs:response.data.results,query:params.data.query}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Activate: function(params){
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.post(
      ServerProperties.ATM_CLOUD.API+'User/Activate/'+params.data.Alias+'/',
      {
        RoleAlias : params.data.RoleAlias,
      }
    )
    .then(function (response) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
    })
    .catch(function (error) {
      params.RunRedux(RequestinProcess({in_process:false,type:null}))
      params.onfailed(error.response.data)
    });
  },
  Forgot: function(params) {
    axios.defaults.headers.post['Authorization'] = null;
    axios.post(
      ServerProperties.ATM_CLOUD.API + 'User/Forgot/',
      {
        Nick : params.data.nick
      })
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  },
  CheckTokenReset: function(params) {
    axios.defaults.headers.post['Authorization'] = null;
    axios.get(ServerProperties.ATM_CLOUD.API + 'User/Forgot/' + params.data.token)
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  },
  Reset: function(params) {
    axios.defaults.headers.post['Authorization'] = null;
    axios.put(ServerProperties.ATM_CLOUD.API + 'User/Forgot/' + params.data.token + '/', {
      Password : params.data.password
    })
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(error.response)
    });
  }
}



// WEBPACK FOOTER //
// ./src/App/user/model/model.js